// extracted by mini-css-extract-plugin
export default {"SuperHubRecipes-gate-content":"SuperHubRecipes-gate-content3VYcPA9JelDN"};